import React from "react";
import ReactLoading from "react-loading";

export function LoadingLine(props) {
  const type = props.type;
  const color = props.color;
  const height = props.height;
  const width = props.width;

  return (
    <ReactLoading
      type={type}
      color={color}
      height={height ? height : "20%"}
      width={width ? width : "20%"}
    />
  );
}
